import { AssignmentType } from '../model';
import { flattenTree } from './array';
import { getLanguages, getModelTranslation } from '../services';
import { translateProperty } from './propertyTranslator';

const invalidStringsMatcher = /^(do not display|not applicable|no_display|\[other values\]|none)$/i;
const isInvalidString = value => typeof (value) == 'string' && value.match(invalidStringsMatcher);
export const showValueForLanguage = lang => (value, variable) => showValue(value, lang, variable);
export const showAccessoryForLanguage = lang => accessory => showAccessory(accessory, lang);
export const getAliases = (usConCode, superCode) => ({ usConCode, superCode });

export function showAccessory(accessory, lang) {
  if (!accessory || !accessory.show) {
    return false;
  }

  if (accessory.values.length === 0) {
    return false;
  }

  const translation = accessory.title;

  if (isInvalidString(translation)) {
    return false;
  }

  return accessory.values.any(showValueForLanguage(lang));
}
//Method to handle dynamic desc of ITCT
export const updateITCTDescription = (description, variable, siteSettings) => {
  var str1 = "SWG service voltage for CD="
  var str2 = "kV"
  if (variable.fullyQualifiedName == "Selector.varCapacitivedDivider") {
    var SW = " "
    var desc = " "
    //var CD=description.substring(0,description.indexOf('Yes')+4)
    var CD = " "
    // var idx = description.indexOf('Yes')+4� � 
    var idx = description.indexOf('Yes');
    if (idx > 0) {
      CD = description.trim().substring(0, description.indexOf('Yes') + 4)
    }
    else {
      //CD=description.substring(0,description.length+4)� � � 
      CD = description.trim().substring(0, description.trim().indexOf('No') + 2)
    }
    //var CD=description.substring(0,description.length+4)
    var idx1 = description.indexOf('SWG')

    if (idx1 > 0) {
      SW = description.substring(description.indexOf('SWG'), description.length)
      desc = description.substring(idx, description.indexOf('SWG'))

    }
    else {
      desc = description.substring(idx, description.length)
    }
    if (desc?.trim() != variable.assignedValue.name) {
      //description = `${CD.trim()} ${variable && variable.assignedValue && variable.assignedValue.name && description.indexOf(variable.assignedValue.name) < 0 ? variable.assignedValue.name: ""} ${SW?.trim()}`;
      //description = `${CD.trim()} ${variable && variable.assignedValue && variable.assignedValue.name ? variable.assignedValue.name : ""} ${SW?.trim()}`;
      description = `${CD.toString().trim()} ${variable && variable.properties && variable.properties.CalculatedValue ? variable.properties.CalculatedValue : ""}`;
      return description;
    }
    else {
      return description;
    }
  }
  else if (variable.fullyQualifiedName == "Selector.varSWGservicevoltageforCD") {
    var SW = " "
    var CD = " "
    var idx1 = description.indexOf('SWG')

    if (idx1 > 0) {
      CD = description.substring(0, description.indexOf('SWG')) + str1

    }
    else {
      CD = description + str1

    }

    if (idx1 > 0) {
      SW = description.substring(description.indexOf('SWG'), description.length)
      var value = SW.substring((SW.indexOf(str1)) + str1.length, SW.indexOf(str2))

    }
    if (value?.trim() != variable.assignedValue.name) {
      description = `${CD.trim()} ${variable.assignedValue.name}${str2?.trim()}  `;
      return description;
    }
    else {
      return description;
    }
  }
}
//Method to handl dynamic description of VT.
export const updateVTDescription = (description, variable, siteSettings) => {
  // const { additionalSpecification } = siteSettings?.properties?.vt;
  var count = 0;
  if (variable.fullyQualifiedName == 'Selector.varFuseDescription') {
    siteSettings?.properties?.vt?.additionalSpecification?.forEach(spec => {
      if (description.includes(spec)) {
        count += 1;
        var fuse_label = description.substring(0, description.indexOf('specification') + 13)
        var list = spec.split(" ");
        var first_text = list[0];
        var idx1 = description.indexOf(first_text);
        var fuse_desc = description.substring(description.indexOf('specification') + 13, idx1 - 2)
        var add_spec = '; ' + description.substring(idx1)
        if (fuse_desc.trim() != variable.assignedValue.name) {
          description = `${fuse_label.trim()} ${variable && variable.assignedValue && variable.assignedValue.name && description.indexOf(variable.assignedValue.name) < 0 ? variable.assignedValue.name : ""} ${add_spec.trim()}`;
          return description;
        }
        else {
          return description;
        }
      }
    })
    if (count == 0) {
      var fuse_label = description.substring(0, description.indexOf('specification') + 13)
      var fuse_desc = description.substring(description.indexOf('specification') + 14)
      if (fuse_desc.trim() != variable.assignedValue.name) {
        description = `${fuse_label.trim()} ${variable && variable.assignedValue && variable.assignedValue.name && description.indexOf(variable.assignedValue.name) < 0 ? variable.assignedValue.name : ""}`

      }
      else {
        return description
      }
    }
  }
  else if (variable.fullyQualifiedName == "Selector.varAdditionalspecification") {

    siteSettings?.properties?.vt?.additionalSpecification?.forEach(spec => {
      if (description.includes(spec)) {
        if (spec.length == 24) {
          var idx = description.indexOf('specification') + 13
          var fuse_spec = description.substring(0, description.indexOf('specification') + 13)
          var add_spec = description.substring(idx + 1)
          if (add_spec.trim() != variable.assignedValue.name) {
            description = `${fuse_spec.toString().trim()} ${variable && variable.assignedValue && variable.assignedValue.name && description.indexOf(variable.assignedValue.name) < 0 ? variable.assignedValue.name : ""} `;
            return description
          }
          else {
            return description
          }
        }
        else {
          var list = spec.split(" ")
          var last = list[list.length - 1]
          var idx = description.indexOf(last) + last.length;
          var desc = description.substring(0, idx);
          var add_spec = description.substring(idx)
          if (add_spec.trim() != variable.assignedValue.name) {
            description = `${desc.trim()} ${variable && variable.assignedValue && variable.assignedValue.name && description.indexOf(variable.assignedValue.name) < 0 ? variable.assignedValue.name : ""} `;
            return description
          }
          else {
            return description;

          }
        }
      }
    })

  }
  var value = variable?.properties?.CalculatedValue;
  var descriptionArr = description.split("Pf");
  var pfCount = descriptionArr.length - 1;
  var windingNo = variable.properties.Name.charAt(10);

  //Pf with "??""
  if (descriptionArr[windingNo]?.includes("??")) {
    var temp = descriptionArr[windingNo].replace('??', value);
    descriptionArr[windingNo] = temp;
  }
  //When Pf selected value is changed
  // Pf value followed by "/"
  else if (!descriptionArr[windingNo]?.includes("     ") && descriptionArr[windingNo]?.includes("/") && !descriptionArr[windingNo]?.includes(value)) {
    var temp = descriptionArr[windingNo].replace(descriptionArr[windingNo].substring(0, descriptionArr[windingNo].length - 1), value);
    descriptionArr[windingNo] = temp;
  }
  //When Pf selected value is changed
  //Pf followed by "     "
  else if (descriptionArr[windingNo]?.includes("     ") && !descriptionArr[windingNo]?.substring(0, 3).includes(value)) {
    var descriptionArr2 = descriptionArr[windingNo].split("     ");
    if (!descriptionArr2[0].includes(value)) {
      descriptionArr2[0] = value;
      if (descriptionArr2[2] != null) {
        var tempStr = descriptionArr2[0] + "     " + descriptionArr2[1] + "     " + descriptionArr2[2];
        descriptionArr[windingNo] = tempStr;
      }
      else {
        var tempStr = descriptionArr2[0] + "     " + descriptionArr2[1];
        descriptionArr[windingNo] = tempStr;
      }

    }
  }


  switch (pfCount - 1) {
    case 0:
      return description = descriptionArr[0] + "Pf" + descriptionArr[1];
    case 1:
      return description = descriptionArr[0] + "Pf" + descriptionArr[1] + "Pf" + descriptionArr[2];
    case 2:
      return description = descriptionArr[0] + "Pf" + descriptionArr[1] + "Pf" + descriptionArr[2] + "Pf" + descriptionArr[3];
  }
}
export const updateProductDescription = (description, configuration, currentNode, siteSettings) => { 
  const  model  = configuration?.model;
  if(!model){
    return description;
  }
  const variables = deflateModelVariables(model);
  const { concatenators, isVT } = currentNode && currentNode.customProperties;
  return concatenators && concatenators.reduce((description, current) => {
    const variable = variables.firstOrDefault(v => v.fullyQualifiedName === current);
    const assignedValue = variable && getAssignedValue(variable);
    //const assignedValue = variable && variable.properties && variable.properties.CalculatedValue ? variable.properties.CalculatedValue : `${variable.title};`+getAssignedValue( variable );
    if (assignedValue) {
      if (isVT && assignedValue != 'Not applicable') {
        description = updateVTDescription(description, variable, siteSettings);
      }
      else if (!isVT) {
        description = updateITCTDescription(description, variable, siteSettings);

      }
    }
    else if (!assignedValue && variable.fullyQualifiedName == 'Selector.varCapacitivedDivider') {
      description = description.trim().substring(0, description.indexOf('Yes') + 4)
    }
    else if (!assignedValue && variable.fullyQualifiedName == 'Selector.varSWGservicevoltageforCD' && description.indexOf('SWG') > 0) {
      description = description.trim().substring(0, description.indexOf('SWG'))
    }
    return description
  }, description);
}

export const getUnit = (variable, groupVariables) => {
  if (!variable.properties.Unit || variable.properties.Unit.indexOf('Show:') !== 0) {
    return '';
  }
  const unitVariable = variable.properties?.Unit?.substring( 'Show:'.length );
  const matchingUnit = groupVariables.firstOrDefault( v => v.name === unitVariable );
  if ( !matchingUnit || !matchingUnit.assignedValue || !matchingUnit.assignedValue.title ) {
    return '?';
  }
  return ` (${matchingUnit.assignedValue.title})`;
};

export const isUserAssigned = accessory => accessory && accessory.assignedValue && !accessory.assignedValue.properties.Default;

export function isAssignedAccessory(accessory, lang) {
  return accessory
    && accessory.show
    && accessory.assignedValue
    && !isInvalidString(accessory.assignedValue.title)
    && (!accessory.group || accessory.group !== 'Selector');
}

export function isContained(invalidVariables, variable) {
  for (let invalid of invalidVariables) {
    if (invalid.name === variable.name) {
      return true;
    }
  }
  return false;
}

export const assignmentDecision = (productModelType, lang) => {
  if (productModelType !== 1) {
    return acc => {
      if (acc.group === 'Selector') {
        return acc.name === 'Variant' && (
          acc.assignedValue && acc.assignedValue.name !== 'Not applicable' || acc.properties.DefaultValue || acc.properties.CalculatedValue);
      }
      // for vt models we should check the property if it is a bomItem or not
      if (acc.properties.IsBomItem !== undefined) {
        return (
          acc.properties.IsBomItem
          && acc.assignedValue
          && acc.assignedValue.name !== 'Not applicable'
          && acc.assignedValue.name !== 'None'
        );
      }
      if (acc.properties.IsForUi !== undefined) {
        return !acc.properties.IsForUi
          && acc.group === 'Configuration'
          && acc.assignedValue
          && acc.assignedValue.name
          && acc.assignedValue.name.indexOf('1SDA') === 0
          && (
            acc.assignedValue.name !== '-' && acc.assignedValue.name !== 'No' &&
            acc.assignedValue.title !== 'None' && acc.assignedValue !== '-'
          );
      }
      // when no bom item, continue with default handling
      return isAssignedAccessory(acc, lang);
    };
  }
  return acc => isAssignedAccessory(acc, lang);
};

export function createCodeFromConfiguration(variables, { settings }) {
  return variables
    .where(v => !v.properties[settings.identityProperty || 'dummy'] && v.properties[settings.codeProperty])
    .orderBy(v => v.properties[settings.indexProperty])
    .select(v => v.assignedValue ? v.assignedValue.name : '').join('');
}

export function getAccessories(product,fromCart=false,onExport=false) {
  if (!product) {
    return [];
  }
  const { configuration } = product;
  let NST_accessories=[];
  if(product.configurableProduct?.length>0 && !fromCart){
    product.bomItems?.forEach(b=> b.configuredAcc && NST_accessories.push(b.name))
  }
  if (!configuration) {
    if(NST_accessories.length>0){
      return NST_accessories}
    return [];
  }
  const { bomComponents } = configuration;
  if (bomComponents && Array.isArray(bomComponents) && bomComponents.length > 0) {
    return bomComponents.filter(m => m !== null && m !== undefined).map(m => m.component);
  }
  if(!checkIsBomItemMain(configuration)||!configuration.bomComponents) {
  const accessories = deflateModelVariables(product.configuration.model);
  const lang = getLanguages()[0] || 'EN';
  const accessoryList= accessories.filter(accessory =>
    assignmentDecision( product.configuration.productModelType, lang )( accessory ) && getAssignedValue( accessory ) !== product.configuration.product.name && accessory?.assignedValue?.name && !NST_accessories.find(acc=>!(product.configuration?.model?.title=="ACC_Emax2_IEC") && acc==accessory.assignedValue.name) )
    .map(getAssignedValue);
    if (product.configuration?.model?.title=="ACC_Emax2_IEC"){return accessoryList}
    const finalAccList=  NST_accessories.concat(accessoryList)
    return finalAccList
  }
  return [];
}

export function showValue(value, lang) {
  if (!value) {
    return false;
  }

  // check for blocked
  if (value.state === 3) {
    return false;
  }
  // when its forceable, and author is not default (for default author show the forceabale value)
  if (value.state == 4 && value.author != 3) {
    return false;
  }
  var translation='';
  if(typeof value.title=="string"){
    translation = value.title;
  }
  else{
    translation=value.title.props?.children;
  }

  if (isInvalidString(translation)) {
    return false;
  }

  return true;
}

export const isValid = variable => !variable.properties || variable.properties.valid;

export const isValidWithValidityInfo = (variable, validityInfo) => !validityInfo || validityInfo.invalidVariables.none(iv => iv.name === variable.name);

export const isRequired = variable => variable.properties && variable.properties.Required || variable.isRequired;

export const isRequiredAndUnselected = variable => isRequired(variable) && !variable.assignedValue;

export const getAssignedValue = variable => variable && variable.assignedValue && variable.assignedValue.name !== ']-inf;inf[' && variable.assignedValue.name !== '[Other values]'
  ? variable.assignedValue.name
  : variable.showAs === 'Calculated'
    ? variable.properties.CalculatedValue
    : variable.properties.DefaultValue;

export const getValues = (variable, values, lang) => {
  // TODO: evaluate variable.properties.DisplayforceableAs if we could use it
  // to enable different strategies for hiding items that are forceable
  return values.where(showValueForLanguage(lang, variable)).select();
};

export const hasAnyAssignableValues = group => {
  return group.variables.any(variable =>
    variable.show && variable.values.length > 0 && variable.values.any(val => AssignmentType.isAvailable(val) && (val.name !== 'Not applicable' || val.name !== 'None'))
  ) || group.hasChildren && group.children.any(hasAnyAssignableValues);
};

/**
 * Will cache flattening of a model for 1 minute, with sliding expiration
 * This method assumes that the model reference will change, so it will use the map to make sure it works only on the same references
 * TODO: implement a sliding cache in an easier way
 * @method deflateModelVariables
 * @param { object } model Themodel which will be used to flatten an array
 * @returns {object[]} An array of variables on the model, including their fqn, it can either be cached, or retrieved anew
 */
export const deflateModelVariables = (model) => {
  if (!deflateModelVariables._cache) {
    deflateModelVariables._cache = new Map();
  }
  let cache = deflateModelVariables._cache.get(model);
  if (cache) {
    // clear the initial timeout
    clearTimeout(cache.timeout);
    // create a new timeout for 1 minute
    cache.timeout = setTimeout(() => {
      deflateModelVariables._cache.delete(model);
    }, 1 * 1000 * 60);
    return cache.cache;
  }
  cache = flattenTree('children', 'hasChildren', 'variables')(model, (items, ...parents) => items.map(item => ({ ...item, group: parents?.map(p => p.title).join('.') })));
  // save the item to cache and set a timeout to be removed in 1 minute
  deflateModelVariables._cache.set(model, {
    cache,
    timeout: setTimeout(() => {
      deflateModelVariables._cache.delete(model);
    }, 1 * 1000 * 60)
  });
  return cache;
};

// export const getUserAssignments = ({ model },flag=false) => {
//   const setClearCacheTimeout = () => setTimeout(() => getUserAssignments._cache.delete(model), 1 * 1000 * 60);
//   if (!getUserAssignments._cache) {
//     getUserAssignments._cache = new Map();
//   }

//   let cache = getUserAssignments._cache.get(model);
//   if (cache) {
//     // clear the initial timeout
//     clearTimeout(cache.timeout);
//     // create a new timeout for 1 minute
//     cache.timeout = setClearCacheTimeout();
//     if(flag){
//       cache = deflateModelVariables( model )
//       .where( variable => {if(variable.properties?.IsBomItem && variable.assignedValue && variable.assignedValue?.name!="None"){return variable.assignedValue && variable.isUserAssignment  && variable.assignedValue.name !== '[Other values]'  } else{ return variable.show  && variable.assignedValue && variable.assignedValue?.author==0 && variable.assignedValue.name !== '[Other values]'}} )
//       .select( variable => ( { 
//       assignmentType: 2, 
//       key: variable.fullyQualifiedName, 
//       value: variable.assignedValue.name,
//       isDefault: variable.isDefault
//     } ) )
//     return cache;
//     }
//     return cache.cache;
//   }
//   if(flag){
//     cache = deflateModelVariables( model )
//     .where( variable => {if(variable.properties?.IsBomItem && variable.assignedValue && variable.assignedValue?.name!="None"){return variable.assignedValue && variable.isUserAssignment  && variable.assignedValue.name !== '[Other values]'  } else{ return variable.show  && variable.assignedValue && variable.assignedValue?.author==0 && variable.assignedValue.name !== '[Other values]'}} )
//     .select( variable => ( { 
//       assignmentType: 2, 
//       key: variable.fullyQualifiedName, 
//       value: variable.assignedValue.name,
//       isDefault: variable.isDefault
//     } ) )
//   }
//   else{
//   cache = deflateModelVariables(model)
//     .where(variable => variable.assignedValue && variable.isUserAssignment && variable.assignedValue.name !== '[Other values]')
//     .select(variable => ({
//       assignmentType: 2,
//       key: variable.fullyQualifiedName,
//       value: variable.assignedValue.name,
//       isDefault: variable.isDefault
//     } ) )};

//   // save the item to cache and set a timeout to be removed in 1 minute
//   getUserAssignments._cache.set(model, { cache, timeout: setClearCacheTimeout() });
//   return cache;
// };
export const getUserAssignments = ( { model } ) => {
  const setClearCacheTimeout = () => setTimeout( () => getUserAssignments._cache.delete( model ), 1 * 1000 * 60 );
  if( !getUserAssignments._cache ) {
    getUserAssignments._cache = new Map();
  }

  let cache = getUserAssignments._cache.get( model );
  if( cache ) {
    // clear the initial timeout
    clearTimeout( cache.timeout );
    // create a new timeout for 1 minute
    cache.timeout = setClearCacheTimeout();
    return cache.cache;
  }
  cache = deflateModelVariables( model )
    .where( variable => variable.assignedValue && variable.assignedValue.name !== '[Other values]' && !isInvalidString(variable.assignedValue.name) )
    .select( variable => ( { 
      assignmentType: 2, 
      key: variable.fullyQualifiedName, 
      value: variable.assignedValue.name,
      isDefault: variable.isDefault
    } ) );

  // save the item to cache and set a timeout to be removed in 1 minute
  getUserAssignments._cache.set( model, { cache, timeout: setClearCacheTimeout() } );
  return cache;
};

export const getMissingBomItemCodes = (items, availableItems = {}) => {
  const codes = [];
  const lang = getLanguages().first();

  for (let item of items) {
    !availableItems[item.name] && !codes.any(code => code === item.name) && codes.push(item.name);

    if (item.configuration) {
      const accessories = deflateModelVariables(item.configuration.model);
      const configCodes = accessories
        .filter(accessory => assignmentDecision(item.configuration.productModelType, lang)(accessory) && getAssignedValue(accessory) !== item.configuration.product.name)
        .map(getAssignedValue);
      for (let configCode of configCodes) {
        !availableItems[configCode] && !codes.any(code => code === configCode) && codes.push(configCode);
      }
      //Adding Missed BomComponents back to the codes to update the products Object with all the codes in the configuration
      item.configuration.assignments.filter(assign => assign.key === null).map(assign => { codes.push(assign.value) });
      item.superCodeLSO && codes.push(item.superCodeLSO)
    }
    if(item.looseAdditionalProduct && item.looseAdditionalProduct.length>0){
      const accessories = item.looseAdditionalProduct[0]?.configuration && deflateModelVariables( item.looseAdditionalProduct[0]?.configuration.model );
      const configCodes = accessories
      .filter( accessory => assignmentDecision( item.looseAdditionalProduct[0]?.configuration.productModelType, lang )( accessory ) && getAssignedValue( accessory ) !== item.looseAdditionalProduct[0].configuration.product.name )
      .map( getAssignedValue );
      for( let configCode of configCodes ) {
        !availableItems[configCode] && !codes.any( code => code === configCode ) && codes.push( configCode );
      }
    }
  }
  return codes;
};

export const getPreselectionAssignments = (configuration, currentSelector) => {
  if (!currentSelector.preFilters || !currentSelector.preFilters.length) {
    return [];
  }

  const variables = deflateModelVariables(configuration.model);
  const allAssignments = currentSelector.preFilters.reduce((total, prefilter) => {
    const variable = variables.firstOrDefault(variable => variable.fullyQualifiedName.includes(prefilter.identifier));
    const assignments = !variable
      ? []
      : variable.values
        .filter(value => prefilter.values.any(preval => preval.value === value.name))
        .map(value => ({ key: variable.fullyQualifiedName, value: value.name }));
    return total = [...total, ...assignments];
  }, []).filter(assignment => assignment);
  return allAssignments;
};

export const PricingModule = {
  Materials: 0,
  Sap: 1,
  Runtime: 2,
  Other: 3,
  None: 4,
  RemoteRuntime: 5,
  Phase2: 6,
  RemoteRuntimeSQL: 7,
  0: 'Materials',
  1: 'SAP',
  2: 'Runtime',
  3: 'Other',
  4: 'None',
  5: 'RemoteRuntime',
  6: 'Phase2',
  7: 'RemoteRuntimeSQL',
  showPrice(pricingModule) {
    return pricingModule !== PricingModule.None && pricingModule !== PricingModule.Other;
  },
  requestPrice(pricingModule) {
    return (
      pricingModule === PricingModule.Sap ||
      pricingModule === PricingModule.Runtime ||
      pricingModule === PricingModule.RemoteRuntime ||
      pricingModule === PricingModule.Materials ||
      pricingModule === PricingModule.Phase2 ||
      pricingModule === PricingModule.RemoteRuntimeSQL
    );
  }
};

export const ProductModelType = {
  VT: 0,
  SAP: 1,
  ACE: 2,
  '0': 'VT',
  '1': 'SAP',
  '2': 'ACE'
};

export const getTranslationModelName = (template) => {
  const filewithPath = template.sourceLocation;
  if (!filewithPath) {
    return null;
  }
  const lastIndexOfSlash = filewithPath.lastIndexOf('\\') + 1;
  const lastIndexOfDot = filewithPath.lastIndexOf('.');
  return filewithPath.substr(lastIndexOfSlash, lastIndexOfDot - lastIndexOfSlash);
}

/**
 * Experimental translation service that takes a model & category and returns a function for translating it based on a language
 * It will require a model to be loaded into the translate service before hand, so no validation is happening on that level
 * @param {string} model the name of the model, can use getTranslationModelName to find it
 * @param {model|selector} category either model or selector
 * @returns {function(string)} a function with language as parameter
 */
export const TranslationService = (model, category) => lang => ({
  /**
   * Will try to translate a productElement using the translations from the database before using the properties
   * @param {{ fullyQualifiedName: string, title: string, properties: object[] }} productElement any product model element
   * @returns {object} a shallow copy of the original object with a translated title based on the fullyQualifiedName of the object
   */
  from(productElement) {
    return { ...productElement, title: getModelTranslation(model, productElement.fullyQualifiedName, lang, category) || translateProperty(productElement.properties, productElement.title) };
  },
  /**
   * Will iterate a variables values translated, as well as itself
   * @param {{ fullyQualifiedName: string, title: string, values: object[] }} productElement A variable
   * @returns {object} a shallow copy of the original object with a translated title based on the fullyQualifiedName of the object
   */
  withValues(productElement) {
    const root = this.from(productElement);
    if (root.values) {
      root.values = root.values.map(this.from.bind(this));
    }
    return root;
  },
  /**
   * Will return an element which has variables, and in turn handle the translation for the variables values as well
   * Unlike the withGroups method, it will not iterate any subgroups of that tag
   * @param {{ variables: object[], title: string, fullyQualifiedName: string, values: object[] }} productElement A UIGroup
   * @returns {object} a shallow copy of the original object with a translated title based on the fullyQualifiedName of the object
   */
  withVariables(productElement) {
    const root = this.from(productElement);
    if (root.variables) {
      root.variables = root.variables.map(this.withValues.bind(this));
    }
    return root;
  },
  /**
   * Will iterate a group element and translate all variables & values and groups in one go
   * This is expensive, but it would stop the need of continuously querying for a translation
   * @param {{ children: object[], fullyQualifiedName: string, variables: object[], title: string }} productElement A ProductModel or UIGroup
   * @returns {object} a shallow copy of the original object with a translated title based on the fullyQualifiedName of the object
   */
  withGroups(productElement) {
    const root = this.withVariables(productElement);
    if (root.children) {
      root.children = root.children.map(this.withGroups.bind(this))
    }
    return root;
  },
  fromSelectors(filterSelector) {
    return this.withValues(filterSelector);
  }
});

export const StockModule = {
  Materials: 0,
  Sap: 1,
  None: 2,
  0: 'Materials',
  1: 'Sap',
  2: 'None',
  showStock(availabilityModule) {
    return availabilityModule !== StockModule.None && availabilityModule !== StockModule.Other;
  },
  requestStock(availabilityModule) {
    return (
      availabilityModule === StockModule.Sap ||
      availabilityModule === StockModule.Materials
    );
  }
};

// This method is an extension of the method getAccessories to perform the operations of identifying the accessories an 
// returning the response in the required format while updating price or when updating data from cart reducer, etc
export function getAccessoriesExtended(configuration, importAccessories, forPrices, fromCartReducer, productAmount) {

  if (!configuration) {
    return [];
  }

  if (configuration.bomComponents && configuration.bomComponents.length) {
    if (!forPrices) {
      return configuration.bomComponents.select(component => ({
        assignedValue: {
          name: component.component,
          quantity: component.quantity || productAmount || 1,
        }
      }))
    } else {
      return configuration.bomComponents.select(component => ({
        accessoryCode: component.component,
        quantity: component.quantity || productAmount || 1,
      }))
    }
  }

  if (importAccessories && importAccessories.length) {
    if (!forPrices) {
      return importAccessories.select(component => ({
        assignedValue: {
          name: component.accessoryCode,
          quantity: component.quantity,
          looseacc: component.looseacc
        }
      }))
    } else {
      return importAccessories
    }
  }
  if(!checkIsBomItemMain(configuration)) {
  const lang = getLanguages().first();
  const accessories = configuration && deflateModelVariables(configuration.model);
  const filteredAccessories = accessories.filter(accessory =>
    assignmentDecision(configuration.productModelType, lang)(accessory) &&
    getAssignedValue(accessory) !== configuration.product.name
  );

  
  if (fromCartReducer) {
    return filteredAccessories.map(acc => {
      return {
        accessoryCode: acc.assignedValue.name,
        quantity: productAmount || 1
      }
    })
  }

  if (importAccessories) {
    return filteredAccessories.map(acc => {
      return {
        ...acc,
        quantity: importAccessories.find(ac => ac.accessoryCode == acc.assignedValue.name)?.quantity
      }
    });
  }

  return filteredAccessories;
}

return [];
}

export const checkIsBomItemMain = (configuration) => configuration?.model?.children.any(c => c.variables?.any(v => v.properties.IsBomItem && v.properties.BomItemType === "Main"));